const axios = require('axios').default;
import https from 'https';
import getBrowserLocale from "../utils/getBrowserLocale";
import { assignPrototypesToAPI } from './apiRequests';
import { isValid } from '../utils/utilitiesmodule';

//import router from './'

//axios.defaults.withCredentials = true;
//axios.defaults.httpsAgent = new https.Agent({ keepAlive: true, rejectUnauthorized: false });
var lang = localStorage.getItem('lang');
if (!isValid(lang)) {
    lang = getBrowserLocale({ countryCodeOnly: true });
}
if (!isValid(lang)) {
    lang = "en-US";
}

const api = axios.create({
    withCredentials: true,
    credentials: 'include',
    /*jar: new tough.CookieJar(),  */
    baseURL: process.env.VUE_APP_BASE_URL,
    timeout: 15000,
    httpsAgent: new https.Agent({ keepAlive: true, rejectUnauthorized: false }),
    headers: {
        //'Content-Type': 'application/x-www-form-urlencoded',
        'Accept-Language': lang,
        'Content-Type': "application/json",
        'Cache-Control': "no-cache",
    },

});

/* api.interceptors.request.use(config => {
    // perform a task before the request is sent
    console.log('Request was sent');

    return config;
    }, error => {
        // handle the error
        return Promise.reject(error);
    }); */



api.interceptors.response.use(


    response => {
        return response;
    },
    error => {

        if (error.response) {
            //Token mancante o scaduto
            if (error.response.status == 401) {
                sessionStorage.clear();
                localStorage.removeItem("AUTH")
                window.location.href = "/";

            }
            return Promise.reject(error.response); // Va nel catch
        }

        if (error.toJSON)
            return Promise.reject(error.toJSON()); // Va nel catch
        return Promise.reject(error); // Va nel catch
    });

assignPrototypesToAPI(api)



export default api;